import React from 'react';
import { Chart } from 'react-google-charts';
import BarChartCards from './BarChartCards';
import MyPieChart from './MyPieChart';

const BarChart = ({ allTilesData, barChartData }) => {

  const grouped = {};
  (barChartData || []).forEach((item) => {
    const client = item.ClientName || '';
    if (!grouped[client]) {
      grouped[client] = {
        AllOpen: 0,
        ClosedWon: 0,
        ClosedLost: 0
      };
    }
    if (item.ClientData === 'OpenCost') grouped[client].AllOpen += Number(item.Value) || 0;
    if (item.ClientData === 'WonCost') grouped[client].ClosedWon += Number(item.Value) || 0;
    if (item.ClientData === 'LostCost') grouped[client].ClosedLost += Number(item.Value) || 0;
  });

  const data = [
    ['Client', 'All Open', 'Closed Won', 'Closed Lost'],
    ...Object.entries(grouped).map(([client, values]) => [client, values.AllOpen, values.ClosedWon, values.ClosedLost])
  ];

  const options = {
    isStacked: true,
    chartArea: { width: '60%' },
    hAxis: {
      title: 'Dollar value of All Open, Closed Won and Closed Lost',
      minValue: 0
    },
    vAxis: {
      title: 'Client'
    },
    legend: { position: 'top' },
    colors: ['#002A4E', '#50C0C0', '#404040']
  };

  return (
    <>
      {allTilesData && (
        <>
          <BarChartCards allTilesData={allTilesData} />
          <MyPieChart tilesData={allTilesData} />

          <div style={{ textAlign: 'center', fontSize: 24, fontWeight: 'bold', marginBottom: -25, color: '#000', marginTop: 20, zIndex: 1, position: 'sticky' }}>
            Opportunites by Client
          </div>
          <Chart chartType="BarChart" data={data} options={{ ...options, title: '' }} width={'100%'} height={'500px'} />
        </>
      )}
    </>
  );
};

export default BarChart;
